import { useEffect, useState } from 'react';
import api from '@/shared/api/client';

// Les types d'actifs configures dans Parametres > Menus, pour TOUS les ecrans.
//
// LE DEFAUT QUE CE HOOK FERME
//
// David a ajoute « PAC (sans ECS) » dans l'ecran des menus. La valeur est bien
// enregistree — on la lit en base de pre-production dans `settings.dropdown_menus` —
// mais elle n'apparaissait nulle part ailleurs : la liste deroulante de creation d'un
// actif, le filtre de la liste des clients et celui de la carte ecrivaient leurs cinq
// types EN DUR. Un ecran de configuration dont le reglage ne sort pas de l'ecran est
// pire qu'une absence de configuration : on croit avoir configure.
//
// Le repli n'est pas un habillage : sans lui, une panne de l'appel viderait la liste
// deroulante et empecherait de creer le moindre actif. Il porte les memes valeurs que
// DEFAULT_MENUS cote serveur.
export const TYPES_ACTIFS_PAR_DEFAUT = ['PAC', 'PV', 'Ballon', 'Batterie', 'Autre'];

export default function useTypesActifs() {
  const [types, setTypes] = useState(TYPES_ACTIFS_PAR_DEFAUT);

  useEffect(() => {
    let vivant = true;
    api.get('/admin/menus')
      .then(({ data }) => {
        if (vivant && Array.isArray(data?.types_actifs) && data.types_actifs.length) {
          setTypes(data.types_actifs);
        }
      })
      .catch(() => { /* le repli reste en place : mieux vaut cinq types que zero */ });
    return () => { vivant = false; };
  }, []);

  return types;
}
